// 立即执行，比DOMContentLoaded更早拦截地址
(function() {
    const loc = window.location;
    const urlObj = new URL(loc.href);
    const params = urlObj.searchParams;
    const path = urlObj.pathname;

    // 一、当前页面是集合页，缺少availability参数则自动追加跳转
    if (path.startsWith('/collections/') && !path.includes('/products/')) {
        if (!params.has('filter.v.availability')) {
            params.set('filter.v.availability', '1');
            const newUrl = urlObj.pathname + '?' + params.toString();
            // replace 不增加历史记录
            window.location.replace(newUrl);
            return;
        }
    }

    // 二、批量修改页面内所有集合a标签链接，统一带上availability=1
    function updateCollectionLinks() {
        document.querySelectorAll('a[href]').forEach(a => {
            try {
                const linkUrl = new URL(a.href, loc.origin);
                const linkPath = linkUrl.pathname;
                // 只匹配集合页，排除产品详情页
                if (!linkPath.startsWith('/collections/') || linkPath.includes('/products/')) return;
                // 已有参数跳过
                if (linkUrl.searchParams.has('filter.v.availability')) return;
                linkUrl.searchParams.set('filter.v.availability', '1');
                a.href = linkUrl.toString();
            } catch (err) {
                // 无效链接、锚点、外部链接直接忽略
            }
        });
    }

    // DOM加载完成后更新所有链接
    document.addEventListener('DOMContentLoaded', updateCollectionLinks);
})();